<script setup>
import {
  BuildingStorefrontIcon,
  CircleStackIcon,
  CreditCardIcon,
  PresentationChartBarIcon,
  SignalIcon,
} from '@heroicons/vue/24/outline'
defineProps({ category: { type: String, required: true } })
const icons = {
  PUMP: BuildingStorefrontIcon,
  ATG: CircleStackIcon,
  PRICE_BOARD: PresentationChartBarIcon,
  READER: CreditCardIcon,
  SENSOR: SignalIcon,
}
</script>
<template>
  <component :is="icons[category] || SignalIcon" aria-hidden="true" />
</template>
